module.exports = __webpack_public_path__ + "img/ewm-cxx.ae5f7431.png";